import ImageTag from "../components/reuseable/imageTag";
import FormSection from "../components/login-form/loginForm";
import { useNavigate } from "react-router-dom";

function Login() {
    const navigate = useNavigate();
  return (
    <div className="lg:h-screen flex items-center">
      <div className="flex w-full lg:h-screen rounded-xl">
        <div className="w-[50%] h-full hidden lg:flex items-center justify-center bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md rounded-tr-3xl rounded-br-3xl">
          <ImageTag
            path="/assets/logo.png"
            classes="w-[80%] h-[140px] object-contain"
            altText="login"
          />
        </div>
        <div className=" w-full lg:w-[50%] h-screen lg:h-full my-auto flex flex-col items-center justify-center bg-white">
          <div className="w-[90%] lg:w-[80%] mx-auto flex flex-col items-center justify-center">
            <div className="bg-gradient-to-b from-[#0f172a] to-[#1E293B] shadow-md lg:hidden flex justify-center items-center rounded-xl px-2  py-12 w-[100%] mb-[60px] ">
              <ImageTag
                path="/assets/logo.png"
                classes="w-[80%] h-[120px] object-contain "
                altText="logo"
              />
            </div>
            <div className="w-full pt-8 h-full flex flex-col justify-center">
              <FormSection />
              <div className="flex flex-row justify-center mt-[20px] text-[12px]">
                <a 
                  className="hover:underline hover:text-themeColor hover:cursor-pointer"
                href="/#/PrivacyPolicy">
              Privacy Policy</a>
                         <a 
                 className="ml-[10px] hover:underline hover:text-themeColor hover:cursor-pointer"
                href="/#/TermsAndService">
             Terms & Conditions</a>
                  
                     
                 
                     </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
